import { FormBuilder } from "@/components/form-builder";
import { ForgotPasswordData } from "./schemas";
import { forgotPasswordFormFields } from "./constants";
import { useResetPassword } from "../../hooks/use-reset-password";
import { useResetPasswordProps } from "../../forgot-password.types";

export function ForgotPasswordForm({ successCallback }: useResetPasswordProps) {
  const { onLoginSubmit, isPending } = useResetPassword({ successCallback })

  return (
    <FormBuilder<ForgotPasswordData>
      formId="forgot-password-form"
      fields={forgotPasswordFormFields}
      submitPosition="full"
      submitLabel="Redefinir senha"
      onSubmit={onLoginSubmit}
      isLoading={isPending}
    />
  )
}